import React from 'react';
// import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {ArrowForwardIosRounded} from 'views/icons';

const FilterBarArrow = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translate(50%, -50%)',
        width: {xs: 20, md: 24},
        height: {xs: 44, md: 38},
        borderRadius: 5,
        backgroundColor: 'common.white',
        border: '2px solid',
        borderColor: 'grey.200',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.primary',
        zIndex: 2,
      }}
    >
      <ArrowForwardIosRounded fontSize="small" />
    </Box>
  );
};

export default FilterBarArrow;
